import React, { useEffect } from 'react'
import { useState } from 'react'
import { useSelector } from 'react-redux';
import { handleApiChange } from '../../helper/apiHelperFunctions';
import ImagePreviewCom from '../../components/reportsAndAnalytics/inventoryManagementReportsStack/ImagePreviewCom';
import TableSkeleton from '../../components/dashboard/orderTracking/TableSkeleton';
import Icons from '../../assets/icons';
import { Tooltip as ReactTooltip } from 'react-tooltip'
import LanguageTranslator from '../../locals/LanguageTranslator';
import NoDataFound from '../NoDataFound';
import GenericCustomButton from '../GenericCustomButton';
import { getPayloadFromURLParams } from '../../helper/URLParamsHelper';
import { modifyDataForDocumentViewerUrlInsertion } from '../../helper/helperTableFunctions';

function DocumentViewDetails(props) {
    const { currentTab, isMultipleLevelAvailable, mainLevelData, expandedData, loading, handleChange = () => { }, detailsHeaders = {}, location } = props;
    const { customCols, setAllQtyKeys, imageKey = "" } = props.documentViewerConfig

    const generalStore = useSelector(state => state.generalStore);

    const headersData = detailsHeaders?.[currentTab]?.["headersData"][detailsHeaders?.[currentTab]?.["headersType"]] || {}

    const getHeaderDataMainKey = (isMultipleLevelAvailable?.(mainLevelData || {}) && currentTab === "ITEM") ? "SET" : currentTab;

    const [documentInfo, setDocumentInfo] = useState(null);

    useEffect(() => {
        updateDocumentViewerInfo();
    }, [])

    const updateDocumentViewerInfo = () => {
        let params = getPayloadFromURLParams({ l: location });

        let obj = {};
        if (params?.documentViewerConfig) {
            obj = modifyDataForDocumentViewerUrlInsertion("decode", params?.documentViewerConfig);
            setDocumentInfo(obj);
        } else {
            setDocumentInfo({});
        }
    }

    return (
        <div className='w-full h-full overflow-auto'>
            <div className='overflow-x-auto w-full h-full'>
                {(loading || generalStore.getHeadersData?.isLoading) ? <TableSkeleton /> :
                    <table className='w-full'>
                        <thead className='sticky top-[0] z-[2]'>
                            <tr>
                                {Object.keys(headersData || {}).map((key) =>
                                    <th key={key}>
                                        <LanguageTranslator tag='label'>{headersData?.[key]}</LanguageTranslator>
                                    </th>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {expandedData?.length !== 0 ? getHeaderDataMainKey === "SET" ? expandedData?.map((item) => <>
                                <tr className='bg-[#FAFAFA] h-[32px] align-middle'>
                                    <td className='px-2 py-2'><span className='mb-0 !text-xs !font-semibold !text-[#111D31]'>{item?.set_barcode}</span></td>
                                    <td className='px-2 py-2'><span className='mb-0 !text-[11px] !text-[#525676]'><LanguageTranslator>Single Set Qty:</LanguageTranslator> <span className={`text-[11px] font-semibold text-[#111D31]`}>{item?.single_set_qty}</span></span></td>
                                    <td className='px-2 py-2'><span className='mb-0 !text-[11px] !text-[#525676]'><LanguageTranslator>Total No. Of Set:</LanguageTranslator> <span className={`text-[11px] font-semibold text-[#111D31]`}>{item?.total_no_of_set}</span></span></td>
                                    {Object.keys(setAllQtyKeys || {})?.length > 0 && <td colSpan={100}>
                                        <div className='flex items-center gap-1.5'>
                                            <span className='mb-0 text-[11px] font-semibold text-[#111D31]'><LanguageTranslator>All Quantities</LanguageTranslator> </span>
                                            <Icons.ArrowRightBlack className='shrink-0 mr-0.5'/>
                                            {Object.keys(setAllQtyKeys || {}).map((key,index) => {
                                            return  <>
                                                <span className='text-[11px] text-[#525676]'><LanguageTranslator>{setAllQtyKeys[key]}</LanguageTranslator> <span className={`text-[11px] font-semibold ${setAllQtyKeys[key] === 'Cancelled: ' ? 'text-[#EE5A24]' : setAllQtyKeys[key] === 'GRC: ' ? 'text-[#00891A]' : 'text-[#111D31]'}`}>{item?.[key]}</span></span>
                                                    {index < Object.keys(setAllQtyKeys || {}).length-1 && <div className='ml-1 mr-0.5 h-[10px] w-[1px] bg-borderSlateGrey'></div>}
                                                </>
                                            }
                                            )}
                                        </div>
                                    </td>}
                                </tr>
                                {item?.itemData?.length !== 0 ? item?.itemData?.map((innerItem) => <tr key={item?.id}>
                                    {Object.keys(headersData || {}).map((key) =>
                                        <td key={key}>
                                            {customCols?.[currentTab]?.[key] ?
                                                customCols?.[currentTab]?.[key]?.(innerItem) :
                                                imageKey === key ? <ImagePreviewCom
                                                    className='docViewerTableImage'
                                                    imageUrl={innerItem?.[key]}
                                                    item={innerItem}
                                                    handleChange={handleChange}
                                                /> :
                                                key == "tna_status" ? 
                                                <div className="flex gap-1 cursor-pointer" onClick={() => handleChange("designStage", innerItem)}>
                                                    <div className={`mt-[7px] h-[6px] w-[6px] rounded-full shrink-0 ${documentInfo?.ontrack_status?.toLowerCase?.() === 'on-track' ? "bg-emerald-500" : "bg-rose-500"}`}></div>
                                                    <div>
                                                        <p className={`text-[12px] font-medium underline underline-offset-4 m-0 ${documentInfo?.ontrack_status?.toLowerCase?.() === 'on-track' ? "text-emerald-500" : "text-rose-500"}`}>
                                                            {innerItem?.[key] || "View Status"}
                                                        </p>
                                                        {/* <p className={`text-gray-500 text-[10px] m-0`}>
                                                            18 Jun 2025 19:11
                                                        </p> */}
                                                    </div>
                                                </div>
                                                :
                                                    <label>{innerItem?.[key]}</label>}
                                        </td>
                                    )}
                                </tr>) : <tr><td colSpan="100" className='!border-b-0'><div><NoDataFound /></div></td></tr>}
                            </>) :
                                expandedData?.map((item,outerKey) => <tr>
                                    {Object.keys(headersData || {}).map((key,index) =>
                                        <td className='h-[32px]' key={key}>
                                            {customCols?.[currentTab]?.[key] ?
                                                customCols?.[currentTab]?.[key]?.(item) :
                                                imageKey === key ? <ImagePreviewCom
                                                    className='docViewerTableImage'
                                                    imageUrl={item?.[key]}
                                                    item={item}
                                                    handleChange={handleChange}
                                                /> :
                                                    key == "tna_status" ? <div className="flex gap-1 cursor-pointer" onClick={() => handleChange("designStage", item)}>
                                                    <div className={`mt-[7px] h-[6px] w-[6px] rounded-full shrink-0 ${documentInfo?.ontrack_status?.toLowerCase?.() === 'on-track' ? "bg-emerald-500" : "bg-rose-500"}`}></div>
                                                        <div>
                                                            <p className={`text-[12px] font-medium underline underline-offset-4 m-0 ${documentInfo?.ontrack_status?.toLowerCase?.() === 'on-track' ? "text-emerald-500" : "text-rose-500"}`}>
                                                                {item?.[key] || "View Status"}
                                                            </p>
                                                            {/* <p className={`text-gray-500 text-[10px] m-0`}>
                                                                18 Jun 2025 19:11
                                                            </p> */}
                                                        </div>
                                                    </div> :
                                                <>
                                                        <label
                                                            id={`tooltip-${item?.['apiName']}-${item?.['id']}-${index}-${outerKey}`}
                                                            className='mb-0 max-w-[250px] truncate align-middle'
                                                        >
                                                            {item?.[key]}
                                                        </label>
                                                        {item?.[key]?.toString().length > 38 && <ReactTooltip
                                                            anchorSelect={`#tooltip-${item?.['apiName']}-${item?.['id']}-${index}-${outerKey}`}
                                                            clickable={true}
                                                            border={true}
                                                            borderColor="gray"
                                                            place="left"
                                                            className="tooltip"
                                                            delayShow={.3}
                                                            delayHide={0}
                                                            effect={false}
                                                            globalEventOff="click" // Ensure tooltips are dismissed when another is triggered
                                                            events="hover focus"
                                                            style={{ zIndex: '4', transition: 'none', fontSize: "12px", wordWrap: "break-word", whiteSpace: 'normal', wordBreak: 'break-all', pointerEvents: "auto" }}
                                                        >
                                                            <div className='max-w-[250px] max-h-[200px] overflow-y-auto'>{item?.[key]}</div>
                                                        </ReactTooltip>}
                                                    </>
                                                }
                                                    
                                        </td>
                                    )}
                                </tr>) : <tr><td colSpan="100" className='!border-b-0'><div><NoDataFound/></div></td></tr>}
                        </tbody>
                    </table>
                }
            </div>
        </div>
    )
}

export default DocumentViewDetails